export const extrapayFlowDictIT = {
  extrapayFlowTitle: "Extrapay",
  extrapayFlowProgram: "EXTRAPAY | PROGRAMMA PUNTI",
  extrapayFlowBannerTitle: "I tuoi acquisti aprono nuove possibilità.",
  extrapayFlowBannerSubtitle:
    "Accumula punti sugli acquisti. Ogni 10 acquisti approvati, i punti vengono convertiti in EXC.",
  extrapayFlowOpen: "Apri Extrapay",
  extrapayFlowCyclePoints: "Punti del ciclo",
  extrapayFlowPointsUnit: "punti",
  extrapayFlowPointsAccumulated: "Accumulati sugli acquisti di questo ciclo",
  extrapayFlowOrdersProgress: "{current} di {total} acquisti",
  extrapayFlowCycleLabel: "Ciclo {cycle}",
  extrapayFlowOnePurchaseLeft: "Manca 1 acquisto per concludere il ciclo.",
  extrapayFlowPurchasesLeft: "Mancano {count} acquisti per concludere il ciclo.",
  extrapayFlowCycleComplete: "Ciclo completo. La conversione in EXC avviene automaticamente.",
  extrapayFlowAccumulatedRate: "Tasso di conversione accumulato",
  extrapayFlowRateContinues: "Continua ad accumularsi nei prossimi cicli",
  extrapayFlowPlatformBalance: "SALDO EXC SULLA PIATTAFORMA",
  extrapayFlowAvailableExternal: "Disponibile per l'invio al tuo wallet esterno.",
  extrapayFlowRequestWithdraw: "Richiedi prelievo",
  extrapayFlowLoadError: "Non è stato possibile caricare Extrapay.",
  extrapayFlowRetry: "Riprova",
  extrapayFlowPageSubtitle: "Segui punti, EXC e richieste di prelievo.",
  extrapayFlowPointsTitle: "PUNTI EXTRAPAY",
  extrapayFlowCanRequest: "Puoi richiedere {amount} EXC verso il tuo wallet esterno.",
  extrapayFlowRateNotice:
    "Il tuo tasso di conversione accumulato è {rate}. Continua ad accumularsi nei prossimi cicli.",
  extrapayFlowUnderstandRate: "Capire il tasso",
  extrapayFlowTabPoints: "Punti",
  extrapayFlowTabExc: "EXC",
  extrapayFlowTabWithdrawals: "Prelievi",
  extrapayFlowOrigin: "Origine",
  extrapayFlowDate: "Data",
  extrapayFlowCycle: "Ciclo",
  extrapayFlowPoints: "Punti",
  extrapayFlowViewDetails: "Vedi dettagli",
  extrapayFlowPurchaseOrigin: "Acquisto #{id}",
  extrapayFlowMovement: "Movimento",
  extrapayFlowRequest: "Richiesta",
  extrapayFlowSituation: "Stato",
  extrapayFlowPointsEmpty: "Nessun acquisto approvato trovato.",
  extrapayFlowExcEmpty: "Le conversioni dei punti in EXC compariranno qui al termine di un ciclo.",
  extrapayFlowWithdrawalsEmpty: "Non hai ancora richiesto prelievi di EXC.",
  extrapayFlowPreviousCyclesEmpty: "I cicli già convertiti compariranno qui.",
  extrapayFlowStatusRequested: "Richiesto",
  extrapayFlowStatusAwaiting: "In attesa di trasferimento",
  extrapayFlowStatusConfirmed: "Confermato",
  extrapayFlowStatusConverted: "Convertito",
  extrapayFlowStatusNotConverted: "Non convertito",
  extrapayFlowStatusInProgress: "In corso",
  extrapayFlowStatusAccumulating: "Accumulo acquisti",
  extrapayFlowKnowTitle: "Scopri Extrapay",
  extrapayFlowKnowSubtitle: "Scopri come i tuoi acquisti generano punti e saldo EXC sulla piattaforma.",
  extrapayFlowKnowProgram: "PROGRAMMA PUNTI",
  extrapayFlowKnowHeading: "Come funziona Extrapay",
  extrapayFlowKnowIntro:
    "Extrapay registra punti sugli acquisti con pagamento approvato. Ogni 10 acquisti, questi punti vengono convertiti in Extracoin (EXC), che resta nel tuo saldo sulla piattaforma.",
  extrapayFlowStepPurchase: "ACQUISTO APPROVATO",
  extrapayFlowStepPurchaseNote: "dopo gli sconti · senza spedizione",
  extrapayFlowStepPurchasePoints: "+50 punti",
  extrapayFlowStep1Label: "FASE 1 · PUNTI",
  extrapayFlowStep1Title: "I punti arrivano dopo il pagamento",
  extrapayFlowStep1Body:
    "Ricevi punti pari al 50% del valore dell'acquisto dopo gli sconti. Ad esempio, un acquisto di € 100, senza spedizione, genera 50 punti.",
  extrapayFlowStepCycle: "IL TUO CICLO DI ACQUISTI",
  extrapayFlowStepCycleDone: "10 acquisti approvati",
  extrapayFlowStep2Label: "FASE 2 · CICLO",
  extrapayFlowStep2Title: "Ogni ciclo riunisce 10 acquisti",
  extrapayFlowStep2Body:
    "Ogni acquisto con pagamento approvato conta come una fase. In Extrapay consulti i punti accumulati e quanti acquisti mancano per completare il ciclo.",
  extrapayFlowStepBalance: "SALDO SULLA PIATTAFORMA",
  extrapayFlowStepBalanceNote: "Accredito dopo la conversione",
  extrapayFlowStep3Label: "FASE 3 · CONVERSIONE",
  extrapayFlowStep3Title: "I punti vengono convertiti in EXC",
  extrapayFlowStep3Body:
    "Al decimo acquisto, il sistema moltiplica i punti del ciclo per il tasso di conversione accumulato. Il risultato viene accreditato in EXC sul saldo della piattaforma.",
  extrapayFlowAfterConversionTitle: "Cosa cambia dopo la conversione",
  extrapayFlowAfterConversionBody:
    "Quando l'accredito in EXC è concluso, i punti del ciclo e il contatore degli acquisti tornano a zero. Il tasso di conversione resta accumulato e sarà usato nei cicli successivi.",
  extrapayFlowBalanceSection: "SALDO E PRELIEVO",
  extrapayFlowWhereTitle: "Dove restano gli EXC ricevuti",
  extrapayFlowWhereBody:
    "EXC è la sigla di Extracoin. Dopo la conversione, l'importo resta registrato sulla piattaforma. Per riceverlo in un wallet cripto esterno, devi richiedere un prelievo.",
  extrapayFlowOnPlatform: "Sulla piattaforma",
  extrapayFlowYourExcBalance: "Il tuo saldo EXC",
  extrapayFlowOnExternalWallet: "Nel wallet esterno",
  extrapayFlowSameExcAmount: "La stessa quantità di EXC",
  extrapayFlowWithdrawPath:
    "Quando richiedi il prelievo, indica l'indirizzo del wallet e l'importo. L'importo viene scalato dal saldo della piattaforma alla conferma. Poi il team invia la stessa quantità di EXC all'indirizzo indicato.",
  extrapayFlowFaqTitle: "Dettagli sul calcolo e sul prelievo",
  extrapayFlowFaqSubtitle: "Seleziona una domanda per leggere la spiegazione.",
  extrapayFlowFaqWhen: "Quanti EXC riceverò?",
  extrapayFlowFaqWhenAnswer:
    "La quantità di EXC dipende da due valori: i punti accumulati nel ciclo e il tasso di conversione accumulato. Per questo, cicli diversi possono generare quantità diverse di EXC.",
  extrapayFlowFaqWhenExampleLabel: "UN ESEMPIO",
  extrapayFlowFaqWhenExampleFormula: "500 punti × 0,00070 di tasso = 0,35 EXC",
  extrapayFlowFaqWhenExampleNote:
    "In questo esempio ci sono 10 acquisti da € 100 dopo gli sconti, senza spedizione, usando 18 Extracredit in ogni acquisto e partendo con il tasso a zero. Altri acquisti e tassi possono generare valori diversi.",
  extrapayFlowFaqRate: "Come aumenta il mio tasso di conversione?",
  extrapayFlowFaqRateAnswer:
    "Ogni acquisto somma 3 punti per il calcolo del tasso quando non c'è spedizione, o 6 quando c'è spedizione. Anche la quantità di Extracredit utilizzata viene sommata.",
  extrapayFlowFaqRateAnswer2:
    "Questo punteggio serve solo a calcolare il tasso; non entra nel saldo dei punti del ciclo. Il tasso è il numero usato per convertire i punti in EXC, non una commissione. Il sistema calcola e mostra questo numero in Extrapay.",
  extrapayFlowFaqRateCalcTitle: "Calcolo completo",
  extrapayFlowFaqRateCalcLine1: "Tasso accumulato = punteggio accumulato per il tasso ÷ 3 × 0,00001.",
  extrapayFlowFaqRateCalcLine2:
    "Nell'esempio: 10 × (3 + 18) = 210. Il tasso è 210 ÷ 3 × 0,00001 = 0,00070. Poi, 500 punti × 0,00070 = 0,35 EXC sul saldo della piattaforma.",
  extrapayFlowFaqRateCalcLine3:
    "I punti del ciclo corrispondono al 50% del valore dell'acquisto dopo gli sconti. Il tasso non ha un limite o una scadenza definiti.",
  extrapayFlowFaqWallet: "Devo avere un wallet cripto per iniziare?",
  extrapayFlowFaqWalletAnswer:
    "No. I tuoi EXC restano nel saldo della piattaforma. Devi indicare l'indirizzo di un wallet compatibile con la rete Extracoin solo quando vuoi richiedere un prelievo.",
  extrapayFlowFaqWalletAnswer2:
    "Il credito in Extrapay non è un trasferimento verso il wallet esterno. Quel trasferimento avviene dopo la richiesta ed è effettuato dal team.",
  extrapayFlowKnowCtaTitle: "Consulta il tuo ciclo e il tuo saldo",
  extrapayFlowKnowCtaBody:
    "In Extrapay trovi i punti accumulati, il numero di acquisti e gli EXC disponibili.",
  extrapayFlowKnowCta: "Consulta il mio Extrapay",
  extrapayFlowWithdrawTitle: "Prelievo di token",
  extrapayFlowWithdrawSubtitle: "Consulta il saldo e segui le tue richieste.",
  extrapayFlowWalletAddress: "Indirizzo del wallet Extracoin",
  extrapayFlowWalletAddressHint: "Copia l'indirizzo di ricezione del tuo wallet sulla rete Extracoin.",
  extrapayFlowWithdrawAmount: "Importo del prelievo in EXC",
  extrapayFlowAvailableBalance: "Saldo disponibile sulla piattaforma: {amount} EXC.",
  extrapayFlowReviewWithdraw: "Rivedi prelievo",
  extrapayFlowHowYouReceive: "Come lo riceverai",
  extrapayFlowHowYouReceiveBody:
    "L'Extracoin sarà inviato al wallet che indichi. Verifica che l'indirizzo sia tuo e sia sulla rete Extracoin.",
  extrapayFlowHowYouReceiveDebit:
    "Alla conferma, l'importo viene scalato dal tuo saldo EXC sulla piattaforma. Il team effettuerà il trasferimento dopo.",
  extrapayFlowHowYouReceivePartial:
    "Puoi richiedere una parte del saldo e seguire ogni richiesta in “I miei prelievi”.",
  extrapayFlowDebitNotice: "L'importo richiesto sarà scalato dal tuo saldo EXC sulla piattaforma.",
  extrapayFlowAddressRequired: "Inserisci l'indirizzo del wallet.",
  extrapayFlowAmountRequired: "Inserisci un importo maggiore di zero.",
  extrapayFlowAmountAboveBalance: "L'importo non può superare il saldo disponibile.",
  extrapayFlowConfirmTitle: "Conferma il prelievo",
  extrapayFlowConfirmSubtitle: "Controlla l'indirizzo e l'importo prima di confermare.",
  extrapayFlowYouReceive: "Riceverai",
  extrapayFlowNetwork: "Rete",
  extrapayFlowNetworkName: "Extracoin",
  extrapayFlowDestination: "Indirizzo di destinazione",
  extrapayFlowPlatformDebit: "Addebito dal saldo della piattaforma",
  extrapayFlowBalanceAfter: "Saldo sulla piattaforma dopo la richiesta",
  extrapayFlowConfirmCheck: "Ho controllato l'indirizzo del mio wallet e l'importo del prelievo.",
  extrapayFlowConfirmNote:
    "Alla conferma, l'importo sarà scalato dal tuo saldo EXC sulla piattaforma. L'invio al wallet esterno avverrà dopo.",
  extrapayFlowConfirmAction: "Conferma prelievo",
  extrapayFlowEditValues: "Modifica indirizzo o importo",
  extrapayFlowSuccessTitle: "Richiesta registrata",
  extrapayFlowSuccessSubtitle: "Il saldo è stato aggiornato. Segui il trasferimento nello storico.",
  extrapayFlowAvailableBalanceLabel: "Saldo disponibile",
  extrapayFlowAddress: "Indirizzo",
  extrapayFlowSuccessNote:
    "Il team trasferirà l'importo al tuo wallet. Segui l'aggiornamento in “I miei prelievi”.",
  extrapayFlowTrackWithdraw: "Segui prelievo",
  extrapayFlowMyWithdrawals: "I miei prelievi",
  extrapayFlowWithdrawalsCrumb: "Prelievi",
  extrapayFlowDetailsCrumb: "Dettagli",
  extrapayFlowCycleCrumb: "Dettagli del ciclo",
  extrapayFlowWithdrawDetailsTitle: "Dettagli del prelievo {id}",
  extrapayFlowWithdrawDetailsSubtitle:
    "La richiesta è stata registrata e l'importo è stato scalato dal saldo EXC sulla piattaforma.",
  extrapayFlowRequestDate: "Data della richiesta",
  extrapayFlowUser: "Utente",
  extrapayFlowWithdrawValue: "Importo del prelievo",
  extrapayFlowInformedAddress: "Indirizzo indicato",
  extrapayFlowBackToWithdrawals: "Torna ai prelievi",
  extrapayFlowWithdrawNotFound: "Impossibile trovare questa richiesta.",
  extrapayFlowCycleSubtitle: "Ogni 10 acquisti approvati, i punti vengono convertiti in EXC.",
  extrapayFlowPurchases: "Acquisti",
  extrapayFlowAccumulatedFee: "Tasso accumulato",
  extrapayFlowPointsToConvert: "Punti da convertire",
  extrapayFlowCyclePointsTitle: "Punti del ciclo",
  extrapayFlowViewPoints: "Vedi punti",
  extrapayFlowPreviousCycles: "Cicli precedenti e operazioni",
  extrapayFlowOperation: "Operazione",
  extrapayFlowBackToExtrapay: "Torna a Extrapay",
  extrapayFlowConversionTitle: "Conversione del Ciclo {cycle}",
  extrapayFlowConversionFallback: "Conversione",
  extrapayFlowUnavailable: "—",
  extrapayFlowBasicData: "Dati di base",
  extrapayFlowReference: "Riferimento",
  extrapayFlowQuantity: "Quantità",
  extrapayFlowViewFullConversion: "Vedi conversione completa",
  extrapayFlowExcAmount: "{amount} EXC",
  extrapayFlowSignedExc: "+{amount} EXC",
  extrapayFlowSignedPoints: "+{amount}",
  extrapayFlowPurchasePointsTitle: "Punti dell'acquisto #{id}",
  extrapayFlowPurchasePointsSubtitle: "Scopri da dove arrivano i punti di questo movimento.",
  extrapayFlowAmountAfterDiscount: "Importo dopo lo sconto",
  extrapayFlowPointsPercent: "Percentuale in punti",
  extrapayFlowPointsPercentValue: "50%",
  extrapayFlowPointsReceived: "Punti ricevuti",
  extrapayFlowPurchasePointsNote:
    "Questi punti restano nel saldo del ciclo fino alla conversione dopo 10 acquisti.",
  extrapayFlowOtpInvalid:
    "Codice di verifica non valido o scaduto. Controlla la tua e-mail o richiedi un nuovo codice.",
};
